export interface IFormNotification {
    active: boolean;
    metodoNotification: Array<number>;
}

export const initIFormNotification: IFormNotification = {
    active: false,
    metodoNotification: []
}